












































































































































































import FormatDate from '@/helpers/FormatDate'
import CommonTopicService from '@/services/CommonTopicService'
import GroupTopicService from '@/services/GroupTopicService'
import { Prop, Component, Vue } from 'vue-property-decorator'
import { TopicCompactViewModel } from './Layout/NewFeedLayout.vue'
import { getCommonTopicCount } from '@/helpers/GetNotificationCount'
import PreviewText from '@/helpers/PreviewText'
//@ts-ignore
import _ from 'lodash'

import { getModule } from 'vuex-module-decorators'
import CommonTopic from '@/store/modules/CommonTopic'
import store from '@/store'
import { EUserStatus } from '@/models'
import { hanldeUserStatus } from '@/helpers/Common'
import UserInfo from "@/store/modules/UserInfo";

const CommonTopicModule = getModule(CommonTopic, store)
const UserModule = getModule(UserInfo, store)

@Component
export default class ListTopic extends Vue {
  @Prop() topics!: TopicCompactViewModel[]
  @Prop() startLoading!: boolean
  @Prop() disableCheckbox?: boolean
  @Prop() isFromHome?: boolean
  @Prop() isHomeCommon?: boolean
  @Prop() private groupId?: string
  @Prop() isDraft?: boolean
  @Prop() forGroupTop?: boolean
  private isCommonTopic = !this.$route.params.groupId
  noAvatar = require('@/assets/images/avatar-default.png')

  isDisableCheckbox(item: TopicCompactViewModel) {
    const checkedItem = this.topics.find(t => t.checked)

    if (!checkedItem) {
      return false
    }

    return Boolean(item.is_pin) !== Boolean(checkedItem.is_pin)
  }

  /**
   * Handle checkbox / checkAll
   */
  handleCheckItem() {
    const hasAnyChecked = this.topics.some(item => item.checked)

    const unpinTopics = this.topics.filter(item => !item.is_pin)
    const pinTopics = this.topics.filter(item => item.is_pin)

    const allUnpinChecked =
      unpinTopics.length > 0 && unpinTopics.every(item => item.checked)

    const allPinChecked =
      pinTopics.length > 0 && pinTopics.every(item => item.checked)

    if (allUnpinChecked || allPinChecked) {
      this.$emit('addCheckAll')
    } else {
      this.$emit('removeCheckAll')
    }

    this.$emit('selectAnyItem', hasAnyChecked)
  }

  /**
   * Handle click 'mark as read' button
   */
  async handleMarkRead(index: number) {
    this.$blockui.show()
    if ((this.isCommonTopic && !this.isFromHome) || this.isHomeCommon) {
      CommonTopicService.markAsCommonTopicRead(this.topics[index].id)
        .then(res => {
          if (res.status === 200) {
            this.topics[index].is_read = true
            this.$emit('commonTopicReaded', this.topics[index].id)
            this.$emit('subtractReadCount')
            getCommonTopicCount()
            //handle rebind unred count
            CommonTopicModule.SET_RELOAD_UNREAD(true)
          }
        })
        .catch(err => {
          // this.$bvModal.show('modal-error-list-topic')
        })
        .finally(() => this.$blockui.hide())
    } else {
      GroupTopicService.markAsRead(
        this.isFromHome ? String(this.groupId) : this.$route.params.groupId,
        this.topics[index].id
      )
        .then(async res => {
          if (res.status === 200) {
            await GroupTopicService.markAsReadGroupMention(
              this.isFromHome
                ? String(this.groupId)
                : this.$route.params.groupId,
              this.topics[index].id
            )
            this.topics[index].is_read = true
            this.$emit('subtractReadCount')
            //handle rebind unred count
            CommonTopicModule.SET_RELOAD_UNREAD(true)
          }
        })
        .catch(err => {
          // this.$bvModal.show('modal-error-list-topic')
        })
        .finally(() => {
          this.$blockui.hide()
        })
    }
  }

  /**
   * Handle jumping to topic detail page
   */
  jumpToTopicDetailPage(index: number, push?: boolean) {
    const topicId = this.topics[index].id
    let route: any
    if ((this.isCommonTopic && !this.isFromHome) || this.isHomeCommon) {
      route = {
        name: 'common-topic-new-feed-topic-detail',
        params: { topicId: String(topicId), from: this.$route.path }
      }
    } else {
      route = {
        name: 'group-new-feed-topic-detail',
        params: {
          topicId: String(topicId),
          groupId: this.isFromHome
            ? String(this.groupId)
            : this.$route.params.groupId,
          folder: this.$route.query.folder
            ? String(this.$route.query.folder)
            : '',
          from: this.$route.path
        }
      }
    }
    if (push) {
      this.$router.push(route)
    } else {
      return route
    }
  }

  /**
   * Helper format date
   */
  formatDateWithDays(date: string) {
    return FormatDate.formatDateWithDays(date)
  }

  handleLongText(topic: TopicCompactViewModel) {
    // topic.updater.name is from group TOP / topic.updater is from group Topic TOP
    let text = hanldeUserStatus(
      topic.updater.name ? topic.updater.name : topic.updater,
      topic.user_active_status
    )
    const preview = PreviewText.covertToPreviewText(text, 20)
    return {
      name: text,
      text: preview.text
    }
  }

  truncateText(text: string) {
    return _.truncate(text, {
      length: 50,
      separator: ' '
    })
  }

  async togglePinData(topic: TopicCompactViewModel, index: number) {
    if (!this.forGroupTop) {
      if (!topic.is_pin) {
        await this.handleMarkRead(index)
      }
      this.$emit('togglePinData', topic)
    }
  }
}
